import { Link, useNavigate } from "react-router-dom";
import { Button } from "../ui/button";
import { useAuth } from "../../context/AuthContext";

export const BlogHeader = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  return (
    <header className="glass sticky top-0 z-40" data-testid="blog-header">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="blog-header-home-link">
          <div className="w-8 h-8 rounded-full bg-[#1A362D] flex items-center justify-center">
            <span className="text-[#D99C3D] font-display font-bold">T</span>
          </div>
          <span className="font-display text-xl font-semibold tracking-tight">Trackr</span>
          <span className="hidden sm:inline text-xs tracking-[0.2em] uppercase font-semibold text-[#C65D47] ml-2">Guides</span>
        </Link>
        <div className="flex items-center gap-4">
          <Link to="/blog" className="hidden sm:inline text-sm hover:text-[#C65D47] transition-colors" data-testid="blog-header-all-guides-link">
            All guides
          </Link>
          <Link to="/compare" className="hidden sm:inline text-sm hover:text-[#C65D47] transition-colors" data-testid="blog-header-compare-link">
            Compare
          </Link>
          {user?.is_admin && (
            <Link to="/blog/admin" className="text-sm hover:text-[#C65D47] transition-colors" data-testid="blog-header-manage-link">
              Manage posts
            </Link>
          )}
          <Button
            onClick={() => navigate(user ? "/dashboard" : "/register")}
            className="rounded-full bg-[#1A362D] hover:bg-[#2C4A40] text-white px-5 active:scale-95 transition-transform"
            data-testid="blog-header-cta-btn"
          >
            {user ? "Open dashboard" : "Start free"}
          </Button>
        </div>
      </div>
    </header>
  );
};

export const BlogFooter = () => (
  <footer className="border-t border-[#E5E1DB] mt-24">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-10 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-[#5C6B64]">
      <Link to="/" className="font-display text-[#1A362D]">Trackr</Link>
      <div className="flex gap-6">
        <Link to="/blog" className="hover:text-[#C65D47] transition-colors">Guides</Link>
        <Link to="/compare" className="hover:text-[#C65D47] transition-colors">Compare</Link>
        <Link to="/upgrade" className="hover:text-[#C65D47] transition-colors">Pricing</Link>
      </div>
      <span>© {new Date().getFullYear()} — Built for job seekers.</span>
    </div>
  </footer>
);
